import React,{useEffect,useState} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import {getdepartmentData,getCurriculumData,getProgramData,getTemplateData} from "../../../redux/actions/dataAction";
import {connect} from 'react-redux';
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomFilter from '../../../constants/CustomFilter';

const ManageSurveyTemplates = (props) => {
  const [filterData,setFilterData]=useState([]);
  useEffect(()=>{
    props.getdepartmentData()
    props.getCurriculumData()
    props.getProgramData()
    props.getTemplateData()

  },[])
  const [filter,setFilter]=useState({
    department:'Select Department',
    program:'Select Program',
    Surveyfor:'Select Survey For',
  })
  const handleChange=(event)=>{
    setFilter(({...filter,[event.target.id]:event.target.value})) 
  
  }
  const FilterTableData=()=>{
    let data=CustomFilter(props?.template?.data,[
      {value:filter.department,label:'department',initial_value:'Select Department'},
      {value:filter.program,label:'program',initial_value:'Select Program'},
      {value:filter.Surveyfor,label:'survey_for',initial_value:'Select Survey For'},
    ]);
    setFilterData(data);
  }
  const columns=[
    {title:'Name',field:'name'},
    {title:'Description',field:'description'},
    {title:'Type',field:'type'}
  ]
  useEffect(()=>{
    FilterTableData()
  },[props?.template?.data,filter])
  return(
  <div className="customContainer mb-5">
  <CustomHeading title="Template List"/>
  <div className="row">
    <div className="col-md-4">
    <CustomDropdown
      id="department"
      label="Department :"
      data={props?.department?.data?.map(d=>{
          return(
              {value:d.name}
          )
      })}
      notDefaultOption
      defaultOption={"Select Department"}
      onChange={handleChange}
      />
    </div>
    <div className="col-md-4">
    <CustomDropdown
      id="program"
      label="Program :"
      data={props?.program?.data?.map(d=>{
        return(
            {value:d.title}
        )
    })}
      notDefaultOption
      defaultOption={"Select Program"}
      onChange={handleChange}
      />
    </div>
    <div className="col-md-4">
    <CustomDropdown
      id="Surveyfor"
      label="Survey For :"
      data={[
        {value:'PEO'},
        {value:'PO'},
        {value:'CO'},
        {value:'Faculty Feedback'},
        {value:'Facility Feedback'},
        {value:'Student Satisfactory'},
      ]}
      notDefaultOption
      defaultOption={"Select Survey For"}
      onChange={handleChange}
      />
    </div>
  </div>
  <CustomTableWithAll data={filterData} title={"Template List"} buttonRequired={false} columns={columns} api="/api/template/" identify="Template List" />

  </div>
  );
};

const mapActionWithProps = {
  getdepartmentData,
  getCurriculumData,
  getProgramData,
  getTemplateData,
}

const mapStateWithProps = (state)=>(
  {
    department:state.data.department,
    curriculums:state.data.curriculums,
    program:state.data.program,
    template:state.data.template,
  }
)
export default connect(mapStateWithProps,mapActionWithProps)(ManageSurveyTemplates);
